import * as Yup from "yup";

export const initialFilterState = {
  page: 1,
  rows: 10,
  facilityId: 0,
  facilityName: "",
  sortDirection: "",
  SortColumn: "",
  clientId: 0,
  packageTypeId: 0,
  isActive: "",
};

export const YUPValidations = Yup.object().shape({
  packageTypeId: Yup.number().nullable().required("Field is required"),
  isHomeVisitAllowed: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  packageName: Yup.string()
    .required("Field is required")
    .nullable(),
    
    // .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    // .test(
    //   "no-words",
    //   "Package name cannot have age, gender, visit type",
    //   (value) => {
    //     // List of words to check for
    //     const wordsToCheck = [
    //       "male",
    //       "female",
    //       "year",
    //       "center visit",
    //       "centre visit",
    //       "centrevisit",
    //       "homevisit",
    //       "centervisit",
    //       "years",
    //       "visit",
    //       "age",
    //       "yrs",
    //       "home visit",
    //     ];
    //     const wordPattern = new RegExp(
    //       `\\b(${wordsToCheck.join("|")})\\b`,
    //       "i"
    //     );
    //     return !wordPattern.test(value);
    //   }
    // ),
  description: Yup.string()
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  packageDisplayName: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
    // .test(
    //   "no-words",
    //   "Package name cannot have age, gender, visit type",
    //   (value) => {
    //     // List of words to check for
    //     const wordsToCheck = [
    //       "male",
    //       "female",
    //       "year",
    //       "center visit",
    //       "centre visit",
    //       "centrevisit",
    //       "homevisit",
    //       "centervisit",
    //       "years",
    //       "visit",
    //       "age",
    //       "yrs",
    //       "home visit",
    //     ];
    //     const wordPattern = new RegExp(
    //       `\\b(${wordsToCheck.join("|")})\\b`,
    //       "i"
    //     );
    //     return !wordPattern.test(value);
    //   }
    // ),
  // isRateSame: Yup.string(/^[A-Za-z ]*$/).nullable(),
  ageFrom: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .max(Yup.ref("ageTo"))
    .moreThan(0, "Min Age should be greater than zero")
    .required("Field is required"),
  ageTo: Yup.number()
    .nullable()
    .typeError("The field should have digits only")
    .moreThan(0, "Max Age should be greater than zero")
    .required("Field is required"),
  isFastingRequired: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  gender: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  finalReporting: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
  agreedRate: Yup.number().when(["isRateSame", "packageTypeId"], {
    is: (isRateSame, packageTypeId) => {
      // Check if isRateSame is true or packageTypeId is 1
      return isRateSame === "true" || packageTypeId === 1;
    },
    then: Yup.number()
      .typeError("The field should have digits only")
      .max(Yup.ref("mrpRate"))
      .moreThan(0, "APP Customer Rate should be greater than zero")
      .required("Field is required"),
    otherwise: Yup.number(), // No validation if conditions are not met
  }),
  mrpRate: Yup.number().when(["isRateSame", "packageTypeId"], {
    is: (isRateSame, packageTypeId) => {
      // Check if isRateSame is true or packageTypeId is 1
      return isRateSame === "true" || packageTypeId === 1;
    },
    then: Yup.number()
      .typeError("The field should have digits only")
      .moreThan(0, "APP MRP Rate should be greater than zero")
      .required("Field is required"),
    otherwise: Yup.number(), // No validation if conditions are not met
  }),
});

export const PackageCreationHeader = [
  { label: "Package ID", key: "facilityId" },
  { label: "Package Name", key: "facilityName" },
  { label: "Package Type", key: "packageType" },
  { label: "Client Name", key: "clientName" },
  { label: "Fasting", key: "isFasting" },
  { label: "Visit Type", key: "isHVAllowed" },
  { label: "Gender", key: "gender" },
  { label: "Active", key: "isActive" },
];

export const CSVData = (excelData) =>
  excelData?.map((ele) => {
    return {
      facilityId: ele?.facilityId,
      facilityName: ele?.facilityName,
      packageType: ele?.packageType,
      clientName: ele?.clientName,
      isFasting: ele?.isFasting,
      isHVAllowed: ele?.isHVAllowed,
      gender: ele?.gender,
      isActive: ele?.isActive === "Y" ? "Yes" : "No",
    };
  });

export const tableHeaderPackageCreation = [
  {
    name: "Package Name",
  },
  {
    name: "Package Type",
  },
  {
    name: "Client Name",
  },
  {
    name: "Fasting",
  },
  {
    name: "Visit Type",
  },
  {
    name: "Gender",
  },
  {
    name: "Active",
  },
];

export function checkRatesEquality(arr) {
  if (arr.length === 0) {
    return true; // If the array is empty, consider them equal.
  }

  const firstItem = arr[0];

  for (const item of arr) {
    if (
      item.mrpRate !== firstItem.mrpRate ||
      item.agreedRate !== firstItem.agreedRate
    ) {
      return false; // If any item has different rates, return false.
    }
  }

  return true; // All items have the same rates, return true.
}
